import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, kakomonImageSearchFeatureKey } from '../reducers/kakomon-image-search.reducer';

const kakomonImageSearchState = createFeatureSelector<State>(kakomonImageSearchFeatureKey);

export const getKakomonImage = createSelector(kakomonImageSearchState, (state: State) => {
  return state.kakomonImages;
});
